import { useSelect } from '@wordpress/data';
import { SUBSCRIPTIONS_STORE_NAME as STORE_NAME } from '../../constants';

const ProductNames = ({ type, className ='' }) => {
	const products = useSelect(select => select(STORE_NAME).getProducts(type));

	if ( !products || products.length === 0 ) {
		return null;
	}
	
	let productNames = Object.values(products).map(product => product.name);
	
	productNames = productNames.join(', ');

	return (
		<span className={`wds-subscription-product-names ${className}`}>
			({productNames})
		</span>
	);
};	

export default ProductNames;